// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-container {
  display: grid;
  grid-template-columns: 260px 1fr;
  grid-template-rows: auto auto auto auto;
  gap: var(--space-7) var(--space-8);
  padding: 0;
  max-width: var(--layout-page-max);
  margin: 0 auto;
  width: 100%;
}

/* Tablet and mobile: let container use full viewport width */
@media (max-width: 1024px) {
  .product-detail-container {
    max-width: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }
}

@media (max-width: 768px) {
  .product-detail-container {
    padding: 0;
  }
}

.product-detail-image {
  grid-row: 1 / span 2;
  width: 260px;
  height: 260px;
  background: var(--color-surface-muted);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-subtle);
}

.product-detail-main {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-detail-brand {
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.product-detail-title {
  margin-bottom: 16px;
}

.product-detail-meta {
  display: flex;
  gap: 32px;
  margin-bottom: 16px;
}

.add-to-cabinet-btn {
  width: 160px;
  margin-top: 8px;
}

.product-detail-highlights,
.product-detail-howto,
.product-detail-ingredients {
  grid-column: 1 / span 2;
  margin-top: var(--space-4);
  padding: var(--space-6);
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-md);
}

.highlight-tags {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.highlight-tag {
  background: var(--color-surface-muted);
  border-radius: var(--radius-sm);
  padding: 4px 12px;
  font-size: 14px;
  color: var(--color-dark-gray);
}

.product-detail-howto ol {
  margin: 8px 0 0 20px;
  padding: 0;
}

.product-detail-ingredients {
  margin-top: var(--space-6);
}
 `, "",{"version":3,"sources":["webpack://./src/pages/ProductDetailPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;EAClC,UAAU;EACV,iCAAiC;EACjC,cAAc;EACd,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,gCAAgC;EAChC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".product-detail-container {\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  grid-template-rows: auto auto auto auto;\n  gap: var(--space-7) var(--space-8);\n  padding: 0;\n  max-width: var(--layout-page-max);\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Tablet and mobile: let container use full viewport width */\n@media (max-width: 1024px) {\n  .product-detail-container {\n    max-width: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-detail-container {\n    padding: 0;\n  }\n}\n\n.product-detail-image {\n  grid-row: 1 / span 2;\n  width: 260px;\n  height: 260px;\n  background: var(--color-surface-muted);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-subtle);\n}\n\n.product-detail-main {\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.product-detail-brand {\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.product-detail-title {\n  margin-bottom: 16px;\n}\n\n.product-detail-meta {\n  display: flex;\n  gap: 32px;\n  margin-bottom: 16px;\n}\n\n.add-to-cabinet-btn {\n  width: 160px;\n  margin-top: 8px;\n}\n\n.product-detail-highlights,\n.product-detail-howto,\n.product-detail-ingredients {\n  grid-column: 1 / span 2;\n  margin-top: var(--space-4);\n  padding: var(--space-6);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-md);\n}\n\n.highlight-tags {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.highlight-tag {\n  background: var(--color-surface-muted);\n  border-radius: var(--radius-sm);\n  padding: 4px 12px;\n  font-size: 14px;\n  color: var(--color-dark-gray);\n}\n\n.product-detail-howto ol {\n  margin: 8px 0 0 20px;\n  padding: 0;\n}\n\n.product-detail-ingredients {\n  margin-top: var(--space-6);\n}\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
